export default "__VITE_ASSET__M73CgOqH__"